component_goorin_tabs: {
if (window.component_goorin_tabs) { break component_goorin_tabs }

$(document).on('click', 'ul.tabs li[data-tab]', function () {
  var $this = $(this);
  var tab_id = $this.attr('data-tab');
  var parent = $this.closest('.has_parent')

  if ($this.hasClass('sub_cont')) {
    parent
      .find('ul.tabs li , .tab-content , .cm-fc-link ')
      .removeClass('current')
  } else {
    parent
      .find('ul.tabs li , .tab-content , .cm-fc-link ')
      .not('.sub_cont')
      .removeClass('current')
  }

  parent
    .find("#" + tab_id)
    .addClass('current')
    .find('.slick-slider')
    .slick('refresh');

  parent
    .find(".cm-fc-link." + tab_id)
    .addClass('current')

  $this
    .addClass('current')
    .closest('.nav-tabs')
    .scrollingTabs('refresh');
});

$('.nav-tabs').scrollingTabs();

window.component_goorin_tabs = true
}
